module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gkidoi/tc-custom/9781646565030.jpg?1723404397469",
      "alt": "This image is the cover for the book Julio's Wolf, Werewolves of Manhattan"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Julio's Wolf, Werewolves of Manhattan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Julio Reyes has had a hard life. Orphaned at fourteen, he ran away from a group home to avoid rape but wound up being an independent prostitute in NYC. He has a life plan -- go to school, become a stylist and open his own salon."), _c('br'), _c('br'), _vm._v("Etienne Daurensbourg is 139 years old and fears he’ll never find his Mate until his friend Alexei introduces him to Julio. Julio is Etienne’s Mate, but before he has a chance to court Julio -- who is a human high beta and therefore stubborn and independent -- Julio gets knifed and is forced to let Etienne provide him with a home and help to recover."), _c('br'), _c('br'), _vm._v("Pack problems arise that may force Etienne into the pit. Will Julio be able to love Etienne despite the fact he is a loup garou?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      A.C. Katt\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0